import { motion } from "framer-motion";
import { Ruler, ShieldCheck, Sparkles } from "lucide-react";

const ITEMS = [
  { icon: Ruler, label: "Real Measurements", desc: "Every product measured by real people" },
  { icon: ShieldCheck, label: "Fit Tested", desc: "Tried on, not just spec'd out" },
  { icon: Sparkles, label: "No Guesswork", desc: "You know exactly what you're getting" },
];

export default function TrustStrip() {
  return (
    <section data-testid="section-trust-strip" className="py-14 lg:py-20 border-y border-plum/5">
      <div className="max-w-5xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 lg:gap-12">
          {ITEMS.map((item, i) => (
            <motion.div
              key={item.label}
              data-testid={`trust-item-${i}`}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1, duration: 0.5 }}
              className="flex flex-col items-center text-center"
            >
              <div className="w-12 h-12 rounded-full bg-amber/10 flex items-center justify-center mb-4">
                <item.icon className="w-5 h-5 text-amber" />
              </div>
              <h3 className="text-sm font-semibold text-plum tracking-wide">
                {item.label}
              </h3>
              <p className="text-xs text-plum-light mt-1">{item.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
